let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hpPVz")).then(() => parcelRequire('ie3pE'));